<div class="cart-box" (click)="toggleCart()">
  <svg>
    <use href="assets/svg/icon-sprite.svg#stroke-ecommerce"></use>
  </svg>
  <span class="badge rounded-pill badge-primary">{{ cartItems.length }}</span>
</div>
<div class="cart-dropdown onhover-show-div" [class.active]="openCart">
  <h6 class="f-18 mb-0 dropdown-title">Carrito</h6>
  <ul>
    <li *ngFor="let item of cartItems">
      <div class="media">
        <img
          class="img-fluid b-r-5 me-3 img-60"
          [src]="item.image"
          alt="{{ item.name }}"
        />
        <div class="media-body">
          <span>{{ item.name }}</span>
          <div class="qty-box">
            <div class="input-group">
              <span class="input-group-prepend">
                <button
                  class="btn quantity-left-minus"
                  type="button"
                  (click)="updateQuantity(item, -1)"
                >
                  -
                </button>
              </span>
              <input
                class="form-control input-number"
                type="text"
                [value]="item.quantity"
                (change)="onQuantityChange(item, $event)"
              />
              <span class="input-group-append">
                <button
                  class="btn quantity-right-plus"
                  type="button"
                  (click)="updateQuantity(item, 1)"
                >
                  +
                </button>
              </span>
            </div>
          </div>
          <h6 class="font-primary">{{ item.subtotal | currency }}</h6>
          <small class="d-block text-muted text-decoration-line-through" *ngIf="hasOriginalPrice(item)">
            {{ item.originalUnitSalePrice | currency }}
          </small>
          <small class="d-block text-primary" *ngIf="getPromotionSummary(item)">
            {{ getPromotionSummary(item) }}
          </small>
        </div>
        <div class="close-circle">
          <a
            class="bg-danger"
            href="javascript:void(0)"
            (click)="removeFromCart(item)"
          >
            x
          </a>
        </div>
      </div>
    </li>
  </ul>

  <div class="total" *ngIf="cartItems.length > 0">
    <h6 class="mb-0">
      Total: <span class="f-right">{{ total | currency }}</span>
    </h6>
  </div>

  <div class="text-center p-4" *ngIf="cartItems.length > 0">
    <a
      class="d-block view-cart f-w-700"
      [routerLink]="['/ecommerce/cart']"
    >CONFIRMAR COMPRA</a>
  </div>

  <div class="text-center" *ngIf="cartItems.length === 0">    
    <p>El carrito está vacío.</p>
  </div>
</div>
